// extracted by mini-css-extract-plugin
module.exports = {"multi-header":"mobile-two-row-header_multi-header__BzJHb","search-bar-multi":"mobile-two-row-header_search-bar-multi__Cggbg"};